<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">管理员</span>
        <el-input v-model="parameter.user_name" />
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <el-button style="height:37px" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
    </div>
    <div>
      <el-table
        ref="tableRef"
        v-loading="loading"
        :data="tableData.list"
        max-height="650"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="user_name"
          label="管理员"
        />
        <el-table-column
          prop="ad_num"
          label="广告数量"
        />
        <el-table-column
          prop="account_num"
          label="账号数量"
        />
        <el-table-column
          prop="active_num"
          label="投放中数量"
        />
        <el-table-column
          prop="date_time"
          label="创建时间"
        />
      </el-table>
      <pagination-right
        :total="tableData.count"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { adCountList } from '@/api/hugeAdvertGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        user_name: null
      },
      date: []
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await adCountList({ ...this.parameter,
        start_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.tableData = data.data
      this.loading = false
    },

    // 分页
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.getDataList()
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        user_name: null
      }
      this.date = []
      this.getDataList()
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">

.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
      width: 70px;
       text-align: center;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}
</style>

